<template lang="pug">
	.easy-creative--producer-request
		Popup(v-if="visible", :popupVisible.sync="visible",:width="640", :autosize="true")
			.flex-col.space
				.flex-row.space.align-center
					.font-large {{$tCaption('What would you like to have changed?')}}
				.tb-padding
					.flex-col.space
						span {{$tCaption('Please describe what you like to have changed.')}}
						DxTextArea(stylingMode="filled", :value.sync="text", :placeholder="$tCaption('Write something here..', 'creative.EasyCreative')", :height="200", valueChangeEvent="input")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="() => visible = false", :activeStateEnabled="false", :focusStateEnabled="false")
				DxButton(:text="$tCaption('Submit', '@actions')", type="default", @click="doSubmit", :activeStateEnabled="false", :focusStateEnabled="false", :disabled="!text")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxTextArea from 'devextreme-vue/text-area';
	import Popup from 'app-core/Popup.vue';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative--producer-request',
		props: ['info'],
		components: {
			DxButton, DxTextArea, Popup
		},
		data() {
			return {
				text: null,
				visible: false
			};
		},
		computed: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeProducerRequest = this;
			
		},
		methods: {
			onActivate() {
			},
			doSubmit() {
				this.visible = false;
				this.$emit('page', 'results', true);
				setImmediate(() => {
					this.info.results().finishCreative();
				});
			},
			show() {
				this.visible = false;
				setImmediate(() => this.visible = true);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--producer-request {
	}
</style>
